import { fork, all } from 'redux-saga/effects'
import { processSaga, watchSaga } from '../workflow'
// eslint-disable-next-line import/no-named-as-default, temporary until we only export the one thing
import actionTypes from '../../actionTypes'
import actionWorkflows from '../../actionWorkflows'
import { getFeed } from './sagas'

const feedFetch = processSaga.bind(null, actionWorkflows.feedFetch, getFeed)

export default function* root() {
	yield all([
		fork(watchSaga.bind(null, actionTypes.feedFetch, feedFetch, { latest: true }))
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/feed/index.js